<template>
  <div class="baf-wrap">
    <div class="baf-head">
      <h4 class="baf-title">Adicionar uma conta bancária</h4>
      <p class="baf-sub">
        Fique tranquilo, a segurança das informações de sua conta bancária está
        protegida pelo Videomedi.
      </p>
    </div>

    <form class="baf-form">
      <div class="baf-field">
        <label class="baf-label">Banco</label>
        <v-select :options="banksList" label="bank_name" v-model="bank" />
      </div>

      <div class="baf-field">
        <label class="baf-label">Nome completo do titular da conta</label>
        <input
          class="baf-input"
          type="text"
          placeholder="Nome e sobrenome"
          readonly
          :value="$store.state.user.currentUser.name"
        />
      </div>

      <div class="baf-field">
        <label class="baf-label">CPF do titular da conta</label>
        <input
          class="baf-input"
          type="text"
          readonly
          v-mask="'###.###.###-##'"
          :value="$store.state.user.currentUser.cpf"
        />
      </div>

      <div class="baf-row">
        <div class="baf-field">
          <label class="baf-label">Agência</label>
          <input
            class="baf-input"
            type="number"
            v-model="bank_account.agency_number"
          />
        </div>
        <div class="baf-field">
          <label class="baf-label">
            Dígito
            <small>(deixe em branco caso não tenha)</small>
          </label>
          <input
            class="baf-input"
            type="number"
            v-model="bank_account.agency_check_number"
          />
        </div>
      </div>

      <div class="baf-row">
        <div class="baf-field">
          <label class="baf-label">Conta</label>
          <input
            class="baf-input"
            type="number"
            v-model="bank_account.account_number"
          />
        </div>
        <div class="baf-field">
          <label class="baf-label">
            Dígito
            <small>(deixe em branco caso não tenha)</small>
          </label>
          <input
            class="baf-input"
            type="number"
            v-model="bank_account.account_check_number"
          />
        </div>
      </div>

      <p class="baf-warning">
        Certifique-se que todos os dados informados estão corretos. Os bancos
        podem não notar erros até que você transfira os recursos.
      </p>

      <button
        class="baf-submit-btn"
        type="button"
        :disabled="!canCreateBankAccount || isLoading"
        @click="createBankAccount"
      >
        <span>Adicionar conta bancária</span>
        <AppSpinner v-if="isLoading" class="ml-3" variant="light" size="md" />
      </button>
    </form>
  </div>
</template>

<script>
import { Banks as BankService } from "./../services/banks";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import AppSpinner from "./AppSpinner";

export default {
  name: "BankAccountForm",
  components: {
    vSelect,
    AppSpinner
  },
  data() {
    return {
      isLoading: false,
      banks: [],
      bank: {
        bank_name: "",
        bank_number: ""
      },
      bank_account: {
        bank_number: "",
        bank_name: "",
        agency_number: "",
        agency_check_number: "",
        account_number: "",
        account_check_number: ""
      }
    };
  },
  mounted() {
    BankService.fetch()
      .then(response => {
        this.banks = response.data;
      })
      .catch(err => {
        swal.fire({
          icon: "error",
          title: "Erro no servidor",
          text: "Tente novamente mais tarde!"
        });
      });
    this.fillBankAccount();
  },
  methods: {
    deleteBankAccount() {
      swal
        .fire({
          title: "Confirmar exclusão de conta?",
          text: "Você poderá criar uma nova conta logo após!",
          icon: "warning",
          showCancelButton: true
        })
        .then(async result => {
          if (result.isConfirmed) {
            swal.showLoading();
            await this.$store
              .dispatch("doctor/deleteBankAccount")
              .then(() => {
                swal.fire(
                  "Sucesso!",
                  "Sua conta foi deletada com sucesso.",
                  "success"
                );
                this.fillBankAccount();
              })
              .catch(() => {
                swal.fire({
                  icon: "error",
                  title: "Erro ao processar a transação",
                  text: "Tente novamente mais tarde!"
                });
              });
          }
        });
    },
    async saveBankAccount() {
      try {
        this.isLoading = true;
        const bankAccount = Object.assign(this.bank_account, this.bank);
        await this.$store.dispatch("doctor/addBankAccount", bankAccount);

        this.fillBankAccount();
        this.$emit("bankAccountCreated");

        swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Conta bancária cadastrada com sucesso!"
        });
      } catch (error) {
        console.error(error);
        swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível cadastrar a conta bancária."
        });
      } finally {
        this.isLoading = false;
      }
    },
    showErrors(data) {
      var errors = "Dados Inválidos: <br>";
      for (let i in data.errors) {
        errors += `<b>${data.errors[i].description}</b><br>`;
      }

      swal.fire({
        icon: "error",
        title: "Erro ao processar a transação",
        html: errors
      });
    },
    fillBankAccount() {
      if (!this.$store.state.doctor.bank_account.id) {
        this.bank = {
          bank_name: "",
          bank_number: ""
        };
        this.bank_account = {
          agency_number: "",
          agency_check_number: "",
          account_number: "",
          account_check_number: ""
        };

        return;
      }

      this.bank_account = Object.assign(
        {},
        this.$store.state.doctor.bank_account
      );
    },
    createBankAccount() {
      this.saveBankAccount();
    }
  },
  computed: {
    useStyles() {
      return {
        colorGray: {
          color: "#868E96"
        },
        colorDark: {
          color: "#343A40"
        }
      };
    },
    banksList() {
      return this.banks.map(bank => {
        return {
          bank_name: bank.name,
          bank_number: bank.code
        };
      });
    },
    canCreateBankAccount() {
      return (
        this.bank.bank_name &&
        this.bank.bank_number &&
        this.bank_account.agency_number &&
        this.bank_account.account_number
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.baf-wrap {
  padding: 28px;
}

.baf-head {
  margin-bottom: 24px;
  text-align: center;
}

.baf-title {
  margin: 0 0 8px;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 1.25rem;
  font-weight: var(--fw-bold, 700);
  color: var(--color-gray-800, #1e293b);
}

.baf-sub {
  margin: 0;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.875rem;
  color: var(--color-gray-500, #64748b);
  line-height: 1.5;
}

.baf-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.baf-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.baf-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
}

.baf-label {
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.875rem;
  font-weight: var(--fw-semibold, 600);
  color: var(--color-gray-600, #475569);

  small {
    font-size: 0.75rem;
    font-weight: var(--fw-normal, 400);
    color: var(--color-gray-400, #94a3b8);
  }
}

.baf-input {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid var(--color-gray-200, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.9375rem;
  color: var(--color-gray-700, #334155);
  background: #fff;
  outline: none;
  transition: border-color 0.15s;

  &:focus {
    border-color: var(--color-primary, #1a6cf7);
  }

  &:read-only {
    background: var(--color-bg-page, #f4f6fb);
    color: var(--color-gray-400, #94a3b8);
  }
}

.baf-warning {
  margin: 4px 0 0;
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 0.8125rem;
  color: var(--color-gray-400, #94a3b8);
  line-height: 1.5;
}

.baf-submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 24px;
  background: var(--color-primary, #1a6cf7);
  color: #fff;
  border: none;
  border-radius: var(--radius-md, 8px);
  font-family: var(--font-sans, "Nunito Sans", sans-serif);
  font-size: 1rem;
  font-weight: var(--fw-bold, 700);
  cursor: pointer;
  transition: background 0.15s;
  margin-top: 8px;

  &:hover:not(:disabled) {
    background: #155fd4;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>

<style>
.v-select .vs__dropdown-toggle {
  padding: 8px !important;
  border-radius: 8px !important;
  border-color: var(--color-gray-200, #e2e8f0) !important;
}
</style>
